import React, { useState } from 'react';
import { WORKSHOP_2026_FAQ } from '../../data/workshop2026Faq';
import { PAST_WORKSHOPS } from '../../data/workshop2026Content';
import { Meeting } from '../../services/meetingService';
import { formatWorkshopDayTimeRange } from '../../services/workshop2026Service';
import WorkshopFaqInlineAsk from './WorkshopFaqInlineAsk';
import styles from '../../styles/workshop2026Page.module.css';

interface Workshop2026FaqSectionProps {
  isSignedIn: boolean;
  onLoginForQuestion: () => void;
  userEmail?: string;
  userDisplayName?: string;
  meeting?: Meeting | null;
}

const Workshop2026FaqSection: React.FC<Workshop2026FaqSectionProps> = ({
  isSignedIn,
  onLoginForQuestion,
  userEmail,
  userDisplayName,
  meeting = null,
}) => {
  const [expandedId, setExpandedId] = useState<string | null>(null);

  const toggle = (id: string) => {
    setExpandedId((prev) => (prev === id ? null : id));
  };

  return (
    <section className={styles.learnSection}>
      <h2 className={styles.learnHeading}>Frequently asked questions</h2>
      <div className={styles.faqList}>
        {WORKSHOP_2026_FAQ.map((item) => {
          const isOpen = expandedId === item.id;
          return (
            <div key={item.id} className={styles.faqItem}>
              <button
                type="button"
                className={styles.faqQuestion}
                onClick={() => toggle(item.id)}
                aria-expanded={isOpen}
              >
                <span>{item.question}</span>
                <span className={styles.faqChevron} aria-hidden>
                  {isOpen ? '−' : '+'}
                </span>
              </button>
              {isOpen && (
                <div className={styles.faqAnswer}>
                  {item.isAskQuestion ? (
                    <WorkshopFaqInlineAsk
                      isSignedIn={isSignedIn}
                      onLoginForQuestion={onLoginForQuestion}
                      userEmail={userEmail}
                      userDisplayName={userDisplayName}
                    />
                  ) : item.id === 'time-commitment' ? (
                    <p className={styles.faqAnswerText}>
                      The workshop meets {formatWorkshopDayTimeRange(meeting)}, online. Beyond the meeting, you will
                      spend time on step work between sessions — inventories, writing, and meetings with your sponsor.
                      That varies by step and by person.
                    </p>
                  ) : item.id === 'past-workshops' ? (
                    <>
                      <p className={styles.faqAnswerText}>
                        Yes. This is our 12th annual step workshop. In the 11 workshops we&apos;ve held since 2009,
                        more than 200 people have worked all 12 Steps from start to finish.
                      </p>
                      <ul className={styles.pastWorkshopList}>
                        {PAST_WORKSHOPS.map((w) => (
                          <li key={w.year}>
                            <strong>{w.year}</strong> — {w.summary}
                          </li>
                        ))}
                      </ul>
                    </>
                  ) : (
                    <p className={styles.faqAnswerText}>{item.answer}</p>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Workshop2026FaqSection;
